<!-- ********************* SG-7145 start ******************* -->

<div class="first-container">
    <div class="child-one">
        <mat-card fxLayout="column" class="height-class" fxLayoutAlign="space-between center" fxLayoutGap="22px"
            style="word-break: break-all;text-align: center;">
            <ng-container *ngIf="userDetail">
                <div fxLayout="row" fxFlex>
                    <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" fxLayoutGap="12px">
                        <div ngClass="circle" fxLayout="row" fxLayoutAlign="center center">
                            {{userDetail.nameIcon}}</div>
                        <mat-card-title>{{userDetail.usernameDec}}</mat-card-title>
                        <mat-card-subtitle>{{userDetail.emailDec}}</mat-card-subtitle>
                        <span [ngClass]="[userDetail.userRole]"
                            style="font-family: Montserrat !important;color: rgba(0, 0, 0, .87) !important;font-size: 14px;">{{userDetail.userRole}}</span>
                    </div>
                </div>
                <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" fxLayoutGap="12px">
                    <span
                        style="font-family: Montserrat !important;color: rgba(0, 0, 0, .87) !important;font-size: 14px;">Last
                        Active</span>
                    <mat-divider></mat-divider>
                    <mat-card-subtitle fontWeight="700" fxLayoutAlign="center center">{{userDetail.active | date:
                        'longDate'}}</mat-card-subtitle>
                    <mat-card-subtitle fontWeight="700" fxLayoutAlign="center center">{{userDetail.active | date:
                        'shortTime'}}</mat-card-subtitle>
                </div>
            </ng-container>
            <ng-container *ngIf="userDetail?.userDetailsMessage">
                <mat-card-subtitle>&nbsp;</mat-card-subtitle>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
                    {{userDetail.userDetailsMessage}}
                </div>
            </ng-container>
        </mat-card>
    </div>
    <div class="child-two">
        <mat-card fxLayout="column" class="height-class" fxFlex="100%" style="padding: 12px;">
            <mat-card-subtitle cardHeader style="padding-top: 7px;">

                <div class="export-icon"> <span class="mission-heading">{{header}} Records</span>

                    <i class="fa fa-share-square-o" aria-hidden="true"
                        style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                        (click)="exportCsvData('performance')"></i>
                </div>

            </mat-card-subtitle>

            <div class="table-class">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" width="100%">
                    <ng-container matColumnDef="levelType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Level Type</th>
                        <td mat-cell *matCellDef="let element" (click)="openLevelPopUP(element)"
                            style="white-space: nowrap;text-align: justify;padding-left: 0% !important;"
                            [matTooltip]="element.title" pointer>
                            <a class="underline"> {{element.levelType}} </a>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="sessionsPlayed">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Sessions </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.sessionsPlayed" pointer>
                            {{element.sessionsPlayed}} </td>
                    </ng-container>
                    <ng-container matColumnDef="excellentHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Excellent hits </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.excellentHits" pointer>
                            {{element.excellentHits}} </td>
                    </ng-container>
                    <ng-container matColumnDef="goodHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Good Hits </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.goodHits" pointer>
                            {{element.goodHits}} </td>
                    </ng-container>
                    <ng-container matColumnDef="missedHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Missed Hits </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.missedHits" pointer>
                            {{element.missedHits}}</td>
                    </ng-container>

                    <ng-container matColumnDef="voiceCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Voice Commands </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.voiceCommands" pointer>
                            {{element.voiceCommands}} </td>
                    </ng-container>
                    <ng-container matColumnDef="textCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Text Commands </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.textCommands" pointer>
                            {{element.textCommands}} </td>
                    </ng-container>
                    <ng-container matColumnDef="clearedCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Cleared Count </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.clearedCount" pointer>
                            {{element.clearedCount}}</td>
                    </ng-container>
                    <ng-container matColumnDef="notClearedCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> Not Cleared </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.notClearedCount" pointer>
                            {{element.notClearedCount}}</td>
                    </ng-container>
                    <ng-container matColumnDef="percentageCorrect">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="10%"> %Correct </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.percentageCorrect" pointer>
                            {{element.percentageCorrect}}%</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" pointer></tr>
                </table>
            </div>
           
        </mat-card>
    </div>
</div>
<div class="sec-container">
    <div fxLayout="row" [ngClass]="['card-height']" fxLayoutAlign="space-between" fxLayoutGap="10px">
        <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht">
            <mat-card-header class="grp_hdr">
                <article [ngClass]="['header-padding']">
                    <div fxLayout="column" fxLayoutAlign="start center">
                        <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'month' || dateType?.type == 'Month'">
                            Last 24
                            Month's Data</h4>
                        <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'day' || dateType?.type == 'Day'">Last 1
                            Month's Data</h4>
                        <h4 ngClass="selectlist-label" *ngIf="dateType?.type === 'year' || dateType?.type === 'Year'">
                            Last 5
                            Year's Data</h4>
                    </div>
                    <nav class="nv_rt rpd">
                        <div fxLayout="row" fxLayoutGap="10px">
                            <div fxLayout="column" fxLayoutAlign="end center" class="usage-header-inner">
                                <div fxLayout="row">
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                                usageAnalyticsSelectedValue !== 'averageDuration' &&
                                usageAnalyticsSelectedValue!=='masteredPracticeSets' && usageAnalyticsSelectedValue === 'All'">
                                        Usage : </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'TotalSessions'">
                                        Total Lessons Sessions :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'AvgSessionDuration'">Average Lessons
                                        Duration :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'ClearedSessions'">Total Cleared Lessons
                                        :
                                    </h4>

                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'FailedSessions'">Total Not Cleared
                                        Lessons :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'VoiceCommands'">
                                        Total Voice Commands :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'TextCommands'">
                                        Total Text Commands :
                                    </h4>
                                    <mat-form-field class="mrgn drpdown-chart-options duration-dropdown form-field"
                                        appearance="outline">
                                        <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageEramAnalytics"
                                            (selectionChange)="changeAnalytics($event.value)">
                                            <mat-option class="drp-options" *ngFor="let ua of usageEramAnalytics"
                                                [value]="ua.value">
                                                {{ua.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div fxLayout="column">
                                <i class="fa fa-share-square-o" aria-hidden="true"
                                    style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                                    (click)="exportCsvData('usage')"></i>
                            </div>
                        </div>
                    </nav>
                </article>
            </mat-card-header>
            <mat-card-content class="flx_tm">
                <app-highcharts [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
                </app-highcharts>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<!-- ********************* SG-7145 end ******************* -->
